<template>
    <div class="download">

        <div class="main-con">

            <div v-if="type === 'download'">
                <el-table :data="tableData" style="width: 100%" border>
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column prop="title" label="文件名称" min-width="190"></el-table-column>
                    <el-table-column label="下载" min-width="100">
                        <template slot-scope="scope">
                            <template v-if="scope.row.urlList">
                                <a v-for="(item,index) in scope.row.urlList" :key="index" :href="item" target="_blank"
                                    style="color: #eb5c5c;">
                                    免费下载地址{{index+1}}
                                </a>
                            </template>
                            <template v-else>
                                <a :href="scope.row.urlname" target="_blank" style="color: #eb5c5c;">免费下载</a>
                            </template>

                        </template>
                    </el-table-column>
                    <el-table-column prop="infoa" label="使用范围" min-width="190"></el-table-column>
                </el-table>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: '',
    data () {
        return {
            tableData: [],

            type: 'download',
        };
    },

    mounted () {
        this.queryDownload();
    },

    methods: {
        richPreHandler (html) {
            if (!html) return '';

            var res = html;

            res = res.replace(/&nbsp;/g, '');

            return res;
        },
        queryDownload () {
            this.$get(`${this.$store.state.api.webUrl}/index/information/getmoretooldownload.json`, {
                infoid: 9,
                featurecode: this.webInfo.planname,
                featureonly: '1'
            }, (data, res) => {
                
                data = res.tdata;
                var list = data;

                list.forEach(function (item, index) {
                    if (item.by5) {
                        if (item.by5.indexOf(',') != -1) {
                            var url = item.by5.split(',');
                            list[index].urlList = url;
                        }
                    }
                });

                this.tableData = list;
            });
        },

    },
}
</script>


<style lang="scss" scoped>
.download {
    // margin-bottom: 26px;
    background-color: #f5f7fd;
    padding: 30px 0;

    .main-con {
        min-height: 700px;
        width: 1200px;
        margin: 0 auto;
        // border: 1px solid red;
        background-color: #fff;
        padding: 20px;
    }

    .page {
        margin-top: 1em;
    }
}
</style>
